<template>
  <portlet
          :icon="'fal fa-folder-open'"
          :title="'Afspraken'"
  >
    <template slot="portletBody">
      <div v-if="getAppointments.length && getCandidates.length && getCustomers.length">
        <button class="m-show-lg btn btn-secondary w-100 mb-4" @click="filterOpen = !filterOpen">
          <i class="far mr-3" :class="{'fa-filter': !filterOpen, 'fa-times': filterOpen }"></i>
          <template v-if="!filterOpen">
            Filter kandidaten
          </template>
          <template v-else>
            Sluit filter
          </template>
        </button>
        <div class="row dataTable-filters mb-5" :class="filterOpenClass">
          <div class="col-md-4 col-xl-2">
            <div class="dropdown">
              <button class="btn btn-primary dropdown-toggle" type="button">
                <span>{{customFilters[0].options.values.length < 2 ? 'Kandidaat' : 'Kandidaten'}}  ({{customFilters[0].options.values.length}})</span>
              </button>
              <div class="dropdown-menu">
                <input class="form-control mb-3" type="text" placeholder="Zoeken.."
                       v-model="searchName">
                <div class="option-wrapper">
                  <div class="custom-control custom-checkbox"
                       v-for="(candidate, index) in getNames(searchName)"
                       :key="candidate+'-'+index">
                    <input v-model="customFilters[0].options.values"
                           :value="candidate.id"
                           type="checkbox"
                           :id="candidate.fullName+'-'+index"
                           class="custom-control-input"
                    >
                    <label class="custom-control-label" :for="candidate.fullName+'-'+index">
                      <span>{{candidate.firstName}} {{candidate.lastName}}</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4 col-xl-2" v-if="!customerView">
            <div class="dropdown">
              <button class="btn btn-primary dropdown-toggle" type="button">
                <span>{{customFilters[1].options.values.length < 2 ? 'Bedrijf' : 'Bedrijven'}}  ({{customFilters[1].options.values.length}})</span>
              </button>
              <div class="dropdown-menu">
                <input class="form-control mb-3" type="text" placeholder="Zoeken.."
                       v-model="searchCompany">
                <div class="option-wrapper">
                  <div class="custom-control custom-checkbox"
                       v-for="(customer, index) in this.getCustomers.filter(customer => customer.name.indexOf(searchCompany) > -1)"
                       :key="customer+'-'+index">
                    <input v-model="customFilters[1].options.values"
                           :value="customer.id"
                           type="checkbox"
                           :id="customer.name+'-'+index"
                           class="custom-control-input"
                    >
                    <label class="custom-control-label" :for="customer.name+'-'+index">
                      <span>{{customer.name}}</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4 col-xl-2">
            <date-range-picker
                    ref="picker"
                    v-model="picker"
                    opens="center"
                    :showDropdowns="true"
                    :autoApply="true"
                    :locale-data="this.locales"
                    :ranges="this.ranges"
                    @update="updateDateRange"
            >
              <template slot="input" slot-scope="picker">
                <i class="fad fa-calendar"></i> <label>Bereik afspraken</label>
              </template>
            </date-range-picker>
          </div>
        </div>

        <datatables
                :tableClass="tableClass"
                :rows="getAppointments"
                :columns="getColumns()"
                tableID="appointments-dt"
                :deleteFunction="deleteAppointment"
                routerLinkClass="dt-router-link"
                :customFilters="customFilters"
                :tableInitOptions="tableInitOptions"
        ></datatables>
      </div>
      <div v-else>
        Er zijn nog geen afspraken ingepland.
      </div>
    </template>
  </portlet>
</template>

<script>
  import {mapGetters} from 'vuex';
  import {dataTables} from '../../components/mixins/dataTables';
  import {swalModals} from '../../components/mixins/swalModals';


  export default {
    props: ['customer'],
    mixins: [dataTables, swalModals],
    data() {
      return {
        candidate: null,
        customerView: false,
        filterOpen: false,
        filterOpenClass: 'm-hide-lg',
        searchName: '',
        searchCompany: '',
        picker: {
          startDate: null,
          endDate: null,
        },
        locales: {
          direction: 'ltr',
          format: moment.localeData().longDateFormat('L'),
          separator: ' - ',
          applyLabel: 'Opslaan',
          cancelLabel: 'Annuleren',
          weekLabel: 'W',
          customRangeLabel: 'Bereik afspraken',
          daysOfWeek: moment.weekdaysMin(),
          monthNames: moment.monthsShort(),
          firstDay: moment.localeData().firstDayOfWeek()
        },
        ranges: {
          'Vandaag': [moment().startOf('day'), moment().endOf('day')],
          'Gisteren': [moment().subtract(1, 'days').startOf('day'), moment().subtract(1, 'days').endOf('day')],
          'Deze week': [moment().startOf('week'), moment().endOf('week')],
          'Deze maand': [moment().startOf('month'), moment().endOf('month')],
          'Dit jaar': [moment().startOf('year'), moment().endOf('year')],
          'Vorige week': [moment().subtract(1, 'week').startOf('week'), moment().subtract(1, 'week').endOf('week')],
          'Vorige maand': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
          'Toekomst': [moment().startOf('day'), moment().add(100, 'years').endOf('day')]
        },
        tableInitOptions: {
          order: [[2, "desc"], [4, "desc"], [5, "desc"]],
        },
        customFilters: [
          {
            filter: 'arrayContains',
            keyToFilter: 'candidateId',
            options: {
              keyToFilter: null,
              values: []
            }
          },
          {
            filter: 'arrayContains',
            keyToFilter: 'customerId',
            options: {
              keyToFilter: null,
              values: []
            }
          },
          {
            filter: 'dateRangeFilter',
            keyToFilter: 'startDate',
            options: {
              range: {
                min: moment().startOf('day').toDate(),
                max: moment().add(100, 'years').toDate()
              }
            }
          }
        ]
      };
    },
    methods: {
      getNames(searchName) {
        return this.getCandidates.filter(candidate => `${candidate.firstName} ${candidate.lastName}`.toLowerCase().indexOf(searchName.toLowerCase()) > -1)
      },
      getColumns() {
        let self = this;
        return [
          {
            data: null, name: 'Bedrijf', visible: true, searchable: true, orderable: true,
            render(data) {
              console.log(data.customerId)
              try{
              return '<a href="javascript:" data-to="/customers/' + data.customerId + '" class="dt-router-link">' + self.getCustomer(data.customerId).name + '</a>'}catch(e){
                return data.id
              }

            }
          },
          {
            data: null, name: 'Kandidaat', visible: true, searchable: true, orderable: true,
            render(data) {
              let candidate = self.getCandidate(data.candidateId);
              return candidate ? `${candidate.firstName} ${candidate.lastName}` : '<div class="deletedCandidate"">Kandidaat verwijderd</div>';
            }
          },
          {
            data: null, name: 'Datum', visible: false, searchable: true, orderable: true,
            render(data) {
              return data.startDate;
            }
          },
          {
            data: null, name: 'Datum', visible: true, searchable: true, orderable: true,
            render(data) {
              return moment(data.startDate).format('DD-MM-YYYY');
            }
          },
          {
            data: null, name: 'Starttijd', searchable: true, orderable: true,
            render(data) {
              return moment(`2000-01-01 ${data.startTime}`).format('HH:mm');
            }
          },
          {
            data: null, name: 'Eindtijd', searchable: true, orderable: true,
            render(data) {
              return moment(`2000-01-01 ${data.endTime}`).format('HH:mm');
            }
          },
          {
            data: null, name: 'Contactpersoon', searchable: true, orderable: true,
            render(data) {
              return data.contact;
            }
          },
          {
            data: null, name: 'Contactadres', searchable: true, orderable: true,
            render(data) {
              return `<a href="mailto://${data.email}">${data.email}</a>`;
            }
          },
          {
            data: null, name: 'Verwijder', searchable: false, orderable: false,
            render(data) {
              return '<a class="delete action-icon dt-router-link" data-id="' + data.id + '"><i title="Verwijder" class="far fa-trash-alt delete"></i></a>';
            }
          }
        ]
      },
      deleteAppointment(appointment) {
        let candidate = this.getCandidate(appointment.candidateId);
        let startDate = moment(appointment.startDate).format('DD-MM-YYYY');
        let startTime = moment(`2000-01-01 ${appointment.startTime}`).format('HH:MM');
        let endTime = moment(`2000-01-01 ${appointment.endTime}`).format('HH:MM');
        let company = this.getCustomer(appointment.customerId).name;

        this.swalDeleteAppointment(candidate ? `${candidate.firstName} ${candidate.lastName}` : 'de verwijderde kandidaat', startDate, startTime, endTime, company).then(result => {
          if(result.value) {
            this.$store.dispatch('appointments/delete', appointment.id).then(() => {
              this.renderComponent();
              this.$toasted.global.successRequest({
                message: 'Afspraak verwijderd'
              });
            });
          }
        });
      },
      searchByName() {
        return this.getCandidateFullName.filter((search) => {
          return search.fullName.toLowerCase().indexOf(this.searchName.toLowerCase()) >= 0
        })
      },
      /**
       * Set date filters with new values from date range picker and filter table
       * @param dateRange
       */
      updateDateRange(dateRange) {
        this.customFilters[2].options.range.min = moment(dateRange.startDate).startOf('day').toDate()
        this.customFilters[2].options.range.max = moment(dateRange.endDate).endOf('day').toDate()
      }
    },
    computed: {
      ...mapGetters('appointments', ['getAppointments']),
      ...mapGetters('customers', ['getCustomers', 'getCustomer']),
      ...mapGetters('vacancies', ['getVacancyName']),
      ...mapGetters('candidates', ['getCandidates', 'getCandidate', 'getCandidateFullName'])
    },
    watch: {
      'filterOpen': function (value) {
        this.filterOpenClass = value ? 'm-show-flex-lg' : 'm-hide-lg';
      }
    },
    created() {
      moment().locale('nl');
      this.customerView = this.$route.name === 'customer-details'
      if (this.customerView) {
        this.customFilters[1].options.values = [this.customer.id]
      }
    }
  };
</script>
<style>
  .deletedCandidate {
    color: red;
  }
</style>
